/* maligo® – Upselling im Warenkorb (Schublade + Warenkorb-Seite), 19.10.2026.
   1) Nächste Mengenstufe mit echtem Vorteil (Stückpreis, Werbe-Kit, Gratisversand, Großkundenpreis) + Knopf zum Erhöhen.
   2) Mengenvorteil gegenüber dem Einstiegspreis als eigene Zeile (kein künstlich durchgestrichener Preis, Omnibus).
   3) Andere Textur mit demselben Logo (Konfigurator merkt sich das Logo).
   Regeln aus CLAUDE.md: Werbe-Kit ab 3 Trays (J30/Butter) bzw. ab 90 Stk (J12), nie 250 ml; 10 % auf Folgebestellungen ab 5 Trays;
   Gratisversand ab 250 €, nicht Schweiz. Texte kommen aus snippets/maligo-cart-upsell.liquid (window.maligoUpsellT). */
(() => {
  if (window.maligoUpsell) return;
  const T = window.maligoUpsellT || {};
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const OWN = { 'X-Maligo-Probe': '1', Accept: 'application/json' };
  const SKU = /^MLG-(J12|J30|J250|B30|BP30)-([A-Z]+)-(\d{3})$/;
  const KIT_FROM = { J30: 72, J12: 90, B30: 81, BP30: 81 };
  const TOP = { J30: 120, B30: 135, BP30: 135 };
  const TRAY = { J30: 24, B30: 27, BP30: 27 };
  const OTHER = { J12: 'B30', J30: 'B30', J250: 'B30', B30: 'J30', BP30: 'J30' };
  const HANDLE = { B30: 'maligo-aftercare-butter', J30: 'maligo-aftercare-jelly' };
  const country = (window.Shopify && Shopify.country) || '';
  const lang = (document.documentElement.lang || 'de').toLowerCase();
  const loc = lang.startsWith('en') ? 'en-IE' : lang === 'pt-pt' ? 'pt-PT' : lang;
  const eur = (c) => new Intl.NumberFormat(loc, { style: 'currency', currency: 'EUR' }).format(c / 100);
  const fill = (s, o) => String(s || '').replace(/\{(\w+)\}/g, (m, k) => (k in o ? o[k] : m));
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const qty = (code, u) => (TRAY[code] ? fill(T.trays, { n: u / TRAY[code], u }) : fill(T.units, { u }));
  const productCache = {};

  async function product(handle) {
    if (!productCache[handle]) productCache[handle] = fetch(`${ROOT}products/${handle}.js`, { headers: OWN }).then((r) => r.json());
    return productCache[handle];
  }

  async function model() {
    const cart = await (await fetch(`${ROOT}cart.js`, { headers: OWN })).json();
    const lines = cart.items.map((i) => ({ i, m: (i.sku || '').match(SKU) })).filter((x) => x.m);
    if (!lines.length) return null;
    const codes = lines.map((x) => x.m[1]);
    const out = { cart, tier: null, save: 0, cross: null, lines: [] };
    // Hauptzeile = teuerste Private-Label-Zeile
    const main = lines.sort((a, b) => b.i.final_line_price - a.i.final_line_price)[0];
    const [, code, label, n] = main.m;
    const units = +n;
    const p = await product(main.i.handle);
    const same = p.variants
      .map((v) => ({ v, m: (v.sku || '').match(SKU) }))
      .filter((x) => x.m && x.m[1] === code && x.m[2] === label && x.v.available)
      .map((x) => ({ id: x.v.id, units: +x.m[3], price: x.v.price }))
      .sort((a, b) => a.units - b.units);
    const entry = same[0];
    // Mengenvorteil über alle Private-Label-Zeilen gegenüber dem Einstiegspreis derselben Variante
    for (const x of lines) {
      const pp = await product(x.i.handle);
      const vs = pp.variants.map((v) => ({ v, m: (v.sku || '').match(SKU) })).filter((y) => y.m && y.m[1] === x.m[1] && y.m[2] === x.m[2]).map((y) => ({ u: +y.m[3], p: y.v.price })).sort((a, b) => a.u - b.u);
      if (!vs.length) continue;
      const full = Math.round((vs[0].p / vs[0].u) * +x.m[3] * x.i.quantity);
      const sv = Math.max(0, full - x.i.final_line_price);
      out.save += sv;
      if (sv > 0) out.lines.push({ key: x.i.key, index: cart.items.indexOf(x.i) + 1, full, save: sv });
    }
    const next = same.find((s) => s.units > units);
    if (next && entry) {
      const perNow = main.i.final_line_price / main.i.quantity / units;
      const perNext = next.price / next.units;
      const perks = [];
      if (KIT_FROM[code] && units < KIT_FROM[code] && next.units >= KIT_FROM[code]) perks.push(T.kit);
      const delta = next.price - main.i.final_line_price / main.i.quantity;
      if (country !== 'CH' && cart.total_price < 25000 && cart.total_price + delta >= 25000) perks.push(T.ship);
      if (TOP[code] && next.units === TOP[code]) perks.push(T.big);
      const extra = next.units - units;
      const saveNext = Math.max(0, Math.round((entry.price / entry.units) * next.units) - next.price);
      out.tier = { key: main.i.key, props: main.i.properties || {}, next, delta, perNow, perNext, perks, code, extra, marginal: delta / extra, saveNext };
    }
    const other = OTHER[code];
    if (other && !codes.some((c) => (other === 'B30' ? /^BP?30$/.test(c) : /^J/.test(c)))) {
      const op = await product(HANDLE[other]);
      const ov = op.variants.map((v) => ({ v, m: (v.sku || '').match(SKU) })).filter((x) => x.m && x.m[2] === 'ORI' && x.v.available).sort((a, b) => +a.m[3] - +b.m[3])[0];
      if (ov) out.cross = { code: other, price: ov.v.price, url: `${ROOT}products/${HANDLE[other]}?konfigurator=1` };
    }
    return out;
  }

  function html(d) {
    let h = '';
    if (d.tier) {
      const t = d.tier;
      const hasKit = t.perks.includes(T.kit);
      const extra = t.perks.length ? `<span class="mgu__perks">${t.perks.map((x) => `✓ ${esc(x === T.kit ? String(T.kit).split(' (')[0] : x)}`).join(' · ')}</span>` : '';
      const sub = t.saveNext > 0 ? ` · ${esc(fill(T.save_up, { s: eur(t.saveNext) }))}` : '';
      const kitImg = hasKit ? `<img class="mgu__img" src="https://cdn.shopify.com/s/files/1/0978/4279/0745/files/Add-on_set.png?width=96" width="44" height="44" alt="${esc(T.kit)}" loading="lazy">` : '';
      h += `<div class="mgu__row">${kitImg}<span class="mgu__txt"><strong>${esc(fill(T.more, { n: t.extra, p: eur(t.marginal) }))}</strong>${sub}${extra}</span>
        <button type="button" class="mgu__btn" data-mgu-up aria-label="${esc(fill(T.btn, { q: qty(t.code, t.next.units), d: eur(t.delta) }))}">+${esc(eur(t.delta))}</button></div>`;
    }
    // 21.10.2026 (Maui): nur noch die nächste Mengenstufe, keine zweite Textur – zwei Angebote überfordern
    if (false && d.cross) {
      const c = d.cross;
      h += `<a class="mgu__row mgu__x" href="${esc(c.url)}"><span class="mgu__txt">${esc(fill(c.code === 'B30' ? T.x_butter : T.x_jelly, { p: eur(c.price) }))}</span><span class="mgu__arr" aria-hidden="true">→</span></a>`;
    }
    return h;
  }

  function saveHtml(d) {
    return d && d.save > 0 ? `<p class="mgu-save" title="${esc(T.save_note)}"><span>${esc(T.save)}</span><strong>−${esc(eur(d.save))}</strong></p>` : '';
  }

  // Warenkorb-Seite (21.10.2026): Mengenvorteil je Zeile wie in der Schublade (statt-Preis + „−8 % Du sparst …“), Geschenke ohne Papierkorb
  function pageLines(d) {
    const page = document.querySelector('body.template-cart cart-items, .cart-page__content cart-items');
    if (!page || page.closest('cart-drawer')) return;
    page.querySelectorAll('.mgu-line, .mgu-was:not(.mgu-was--gift)').forEach((x) => x.remove());
    page.querySelectorAll('.cart-item').forEach((r) => {
      if (!r.querySelector('a[href*="-beilage"]')) return;
      r.classList.add('mgu-gift-row');
      // Geschenk: kein Papierkorb (wird automatisch beigelegt), „Gratis“ statt 0,00 €
      r.querySelectorAll('cart-remove-button').forEach((x) => x.style.setProperty('display', 'none', 'important'));
      const pw = r.querySelector('.cart-item__price-wrapper');
      if (pw && T.free && !pw.dataset.mgu) {
        pw.dataset.mgu = '1';
        const old = pw.querySelector('s');
        const was = old ? old.textContent.trim() : '';
        pw.innerHTML = `${was ? `<s class="mgu-was mgu-was--gift">${esc(was)}</s> ` : ''}<span class="mgu-pill mgu-pill--free">${esc(T.free)}</span>`;
      }
    });
    if (!d) return;
    for (const l of d.lines) {
      const row = page.querySelector(`#CartItem-${l.index}`);
      const pw = row && row.querySelector('.cart-item__price-wrapper');
      if (!pw) continue;
      const pct = Math.round((l.save * 100) / l.full);
      pw.insertAdjacentHTML('afterbegin', `<s class="mgu-was">${esc(eur(l.full))}</s> `);
      pw.insertAdjacentHTML('afterend', `<p class="mgu-line"><span class="mgu-pill">−${pct} %</span> ${esc(fill(T.line_save, { s: eur(l.save) }))}</p>`);
    }
  }

  // Summe „Dein Mengenvorteil −… €“ direkt über der Zwischensumme (Schublade + Seite, 21.10.2026)
  function sumLine(d) {
    document.querySelectorAll('.mgu-save').forEach((x) => x.remove());
    if (!d || !(d.save > 0)) return;
    const spots = [document.querySelector('cart-drawer .cart-drawer__footer--subtotal')];
    const pageTotals = [...document.querySelectorAll('.cart-page__content .cart__footer .totals')].find((t) => !t.querySelector('.price--total-discount'));
    spots.push(pageTotals);
    spots.filter(Boolean).forEach((el) => el.insertAdjacentHTML('beforebegin', saveHtml(d)));
  }

  // „Gesamtrabatt“ der Warenkorb-Seite (21.10.2026): Gratis-Beilagen zählt Shopify als Rabatt → doppelt und irritierend.
  // Nur Rabatte aus echten Codes zeigen; gibt es keine, Zeile ausblenden.
  async function pageDiscount() {
    const row = [...document.querySelectorAll('.cart-page__content .cart__footer .totals')].find((t) => t.querySelector('.price--total-discount'));
    if (!row) return;
    let cart;
    try { cart = await (await fetch(`${ROOT}cart.js`, { headers: OWN })).json(); } catch (e) { return; }
    const gift = cart.items.filter((i) => /-beilage/.test(i.handle || '')).reduce((n, i) => n + (i.total_discount || 0), 0);
    const real = Math.max(0, (cart.total_discount || 0) - gift);
    row.style.display = real > 0 ? '' : 'none';
    const s = row.querySelector('.price--total-discount s');
    if (real > 0 && s) s.textContent = eur(real);
  }

  // Kasse-Knopf: „Sicher zur Kasse“ statt „Zur Kasse“ (19.10.2026)
  function checkoutLabel() {
    if (!T.checkout) return;
    document.querySelectorAll('button[name="checkout"]').forEach((b) => {
      const sp = b.querySelector('span');
      if (sp && sp.textContent.trim() !== T.checkout) sp.textContent = T.checkout;
    });
  }

  // Papierkorb in die Preiszeile der Produkte (spart eine Zeile, 19.10.2026)
  function moveTrash() {
    document.querySelectorAll('cart-drawer .cart-item:not(.cart-item--probe)').forEach((r) => {
      const rm = r.querySelector('.cart-item__quantity cart-remove-button');
      const pw = r.querySelector('.cart-item__price-wrapper');
      if (!rm || !pw) return;
      pw.style.position = 'relative';
      rm.classList.add('mgu-rm');
      pw.appendChild(rm);
      r.querySelector('.cart-item__quantity').style.display = 'none';
    });
  }

  // Vertrauens-Kasten unter „Sicher zur Kasse“ (19.10.2026): wirkt am Entscheidungspunkt, spart Platz im Scroll-Bereich
  function moveTrust() {
    const box = document.querySelector('cart-drawer .drawer__cart-items-wrapper .mg-trustbox, cart-drawer cart-drawer-items .mg-trustbox');
    const ctas = document.querySelector('cart-drawer .drawer__footer .mg-ctas, cart-drawer .drawer__footer .cart__ctas');
    if (!box || !ctas) return;
    // alle älteren Vertrauensblöcke in der Schublade entfernen (das Theme rendert bei jeder Änderung einen neuen) – sonst doppelt
    document.querySelectorAll('cart-drawer .mg-trustbox').forEach((x) => { if (x !== box) x.remove(); });
    box.classList.add('mgu-trust');
    // 21.10.2026: immer ans Ende des Scrollbereichs (Fuß bleibt auf jedem Gerät kurz, mehr Platz für Artikel)
    const scroll = document.querySelector('cart-drawer .cart-drawer__scroll-area');
    if (scroll) { box.classList.add('mgu-trust--scroll'); scroll.appendChild(box); }
    else ctas.after(box);
  }

  // UID-Hinweis über „Sicher zur Kasse“ (21.10.2026): nur für Lieferland im EU-Ausland (nicht AT, nicht CH).
  // Mit gültiger UID fällt an der Kasse die MwSt. weg (Reverse Charge); das Feld ist dort unter „Weitere Steuerdetails“ versteckt.
  const EU = 'BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE'.split(' ');
  function vatHint() {
    if (!T.vat || !EU.includes(window.maligoUpsellC)) return;
    document.querySelectorAll('.drawer__footer .mg-ctas, .drawer__footer .cart__ctas, .cart__footer .mg-ctas, .cart__footer .cart__ctas').forEach((c) => {
      if (c.parentElement.closest('.mg-ctas, .cart__ctas')) return;
      const prev = c.previousElementSibling;
      if (prev && prev.classList.contains('mgu-vat')) return;
      const p = document.createElement('p');
      p.className = 'mgu-vat';
      p.innerHTML = T.vat;
      c.before(p);
    });
  }

  // Versand + MwSt. konkret (21.10.2026): Sätze aus Shopify-Versandprofil (EU/AT: ≤60 € gratis, 60–250 € AT 9,90 € / EU 17,90 €, ≥250 € gratis;
  // CH: DHL Express CHF 15/45/55/75/110 nach Warenwert, zzgl. Zoll). Sonst wie bisher „an der Kasse“.
  const SHIP_EU = EU.concat(['MC']);
  const chf = (c) => new Intl.NumberFormat(loc, { style: 'currency', currency: 'CHF', maximumFractionDigits: 0 }).format(c / 100);
  function shipText(cart) {
    const X = T.ship_x;
    if (!X) return null;
    const c = window.maligoUpsellC;
    const t = cart.total_price;
    // Schweiz zeigt CHF-Preise; die Staffelgrenzen stehen in EUR → Spanne nennen statt falsch zu rechnen
    if (cart.currency !== 'EUR') return c === 'CH' ? X[5] : X[4];
    if (c === 'CH') {
      const p = t <= 7000 ? 1500 : t <= 25000 ? 4500 : t <= 45000 ? 5500 : t <= 60000 ? 7500 : 11000;
      return fill(X[3], { p: chf(p) });
    }
    if (c === 'AT' || SHIP_EU.includes(c)) {
      if (t <= 6000 || t >= 25000) return X[1];
      return fill(X[2], { p: eur(c === 'AT' ? 990 : 1790) });
    }
    return X[4];
  }
  function taxNote(cart) {
    const X = T.ship_x;
    const txt = shipText(cart);
    if (!X || !txt) return;
    document.querySelectorAll('cart-drawer .tax-note, .cart-page__content .tax-note').forEach((el) => {
      const v = `${X[0]} · ${txt}`;
      if (el.textContent.trim() !== v) el.textContent = v;
    });
  }

  // Vertrauensblock der Schublade (Lieferdatum, Prüfung, Zahlungsarten, WhatsApp) auch auf der Warenkorb-Seite unter dem Kasse-Knopf
  let trustTpl = null;
  async function pageTrust() {
    const ctas = document.querySelector('.cart-page__content .cart__ctas');
    if (!ctas || ctas.parentElement.querySelector('.mg-trustbox')) return;
    if (trustTpl === null) {
      try {
        const j = await (await fetch(`${ROOT}?sections=cart-drawer`, { headers: OWN })).json();
        const doc = new DOMParser().parseFromString(j['cart-drawer'] || '', 'text/html');
        const box = doc.querySelector('.mg-trustbox');
        if (box) { box.querySelector('#CartDrawer-ViewCart')?.previousElementSibling?.remove(); box.querySelector('#CartDrawer-ViewCart')?.remove(); }
        trustTpl = box ? box.outerHTML : '';
      } catch (e) { trustTpl = ''; }
    }
    // hinter den Express-Knöpfen (Shop Pay, PayPal, Google Pay), damit der Vertrauensblock ganz unten steht
    const anchor = ctas.parentElement.querySelector('.cart__dynamic-checkout-buttons') || ctas;
    if (trustTpl && !ctas.parentElement.querySelector('.mg-trustbox')) anchor.insertAdjacentHTML('afterend', trustTpl);
  }

  // Feste Kasse-Leiste am Handy (Warenkorb-Seite): Zwischensumme + „Sicher zur Kasse“, nur solange der echte Knopf nicht im Bild ist
  let stickyIo = null;
  function stickyBar(cart) {
    const real = document.querySelector('.cart-page__content button[name="checkout"]');
    let bar = document.querySelector('.mgu-sticky');
    if (!real || !cart || !cart.item_count) { bar?.remove(); document.body.classList.remove('mgu-sticky-on'); return; }
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'mgu-sticky';
      bar.innerHTML = `<span class="mgu-sticky__sum"><span data-sum></span><small>${esc((T.ship_x || [''])[0])}</small></span><button type="button" class="mgu-sticky__btn">${esc(T.checkout || '')}</button>`;
      bar.querySelector('button').addEventListener('click', () => document.querySelector('.cart-page__content button[name="checkout"]')?.click());
      document.body.appendChild(bar);
      stickyIo = new IntersectionObserver(([en]) => {
        const on = !en.isIntersecting && en.boundingClientRect.top > 0;
        bar.classList.toggle('is-on', on);
        document.body.classList.toggle('mgu-sticky-on', on);
      }, { threshold: 0 });
    }
    bar.querySelector('[data-sum]').textContent = eur(cart.total_price);
    stickyIo.disconnect();
    stickyIo.observe(real);
  }

  // Rabatt als kleiner Textlink „Rabattcode?“ statt Kachel (21.10.2026): lädt weniger zur Gutscheinsuche ein
  function codeLink() {
    if (!T.code) return;
    document.querySelectorAll('.cart-discount .accordion__title').forEach((el) => { if (el.textContent.trim() !== T.code) el.textContent = T.code; });
  }

  let last = null;
  async function render() {
    checkoutLabel();
    moveTrash();
    moveTrust();
    vatHint();
    codeLink();
    let d;
    try { d = await model(); } catch (e) { return; }
    last = d;
    pageTrust();
    if (d && d.cart) { taxNote(d.cart); stickyBar(d.cart); }
    else { try { const c = await (await fetch(`${ROOT}cart.js`, { headers: OWN })).json(); taxNote(c); stickyBar(c); } catch (e) {} }
    const targets = [];
    // 21.10.2026: Karte in den Scrollbereich (nicht vor den festen Fuß), sonst bleibt am iPhone kein Platz für die Artikel
    const scroll = document.querySelector('cart-drawer .cart-drawer__scroll-area');
    const drawer = document.querySelector('cart-drawer .drawer__footer');
    if (scroll) targets.push({ el: scroll, where: 'beforeend' });
    else if (drawer) targets.push({ el: drawer, where: 'beforebegin' });
    const page = document.querySelector('.template-cart cart-items, body.template-cart #main-cart-items, main cart-items');
    if (page && !page.closest('cart-drawer')) targets.push({ el: page, where: 'afterend' });
    for (const t of targets) {
      // alte Karte entfernen, egal ob neben (Fuß/Seite) oder in dem Ziel (Scrollbereich) – sonst doppelt (21.10.2026)
      const host = t.el.parentElement;
      host.querySelectorAll(':scope > .mgu').forEach((x) => x.remove());
      t.el.querySelectorAll(':scope > .mgu').forEach((x) => x.remove());
      if (!d) continue;
      const markup = html(d);
      if (!markup) continue;
      t.el.insertAdjacentHTML(t.where, `<div class="mgu">${markup}</div>`);
    }
    // Reihenfolge im Scrollbereich: Artikel → Upsell → Vertrauen
    const sc = document.querySelector('cart-drawer .cart-drawer__scroll-area');
    const tb = sc && sc.querySelector('.mg-trustbox');
    if (tb) sc.appendChild(tb);
    // 21.10.2026 (Maui): Mengenvorteil als Summe über der Zwischensumme und je Zeile auch auf der Warenkorb-Seite
    sumLine(d);
    pageLines(d);
    pageDiscount();
    // Gratis-Beilagen immer unter die bezahlten Produkte
    document.querySelectorAll('cart-items tbody, .cart-drawer .cart-items, cart-drawer-items .drawer__cart-items-wrapper ul, .cart-items').forEach((list) => {
      const kids = [...list.children];
      const isGift = (r) => Boolean(r.querySelector && r.querySelector('a[href*="-beilage"]'));
      const lastPaid = kids.map(isGift).lastIndexOf(false);
      if (kids.some((r, ix) => isGift(r) && ix < lastPaid)) kids.filter(isGift).forEach((r) => list.appendChild(r));
    });
  }

  async function upgrade(btn) {
    const t = last && last.tier;
    if (!t) return;
    btn.disabled = true; btn.textContent = T.busy;
    try {
      await fetch(`${ROOT}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', ...OWN }, body: JSON.stringify({ items: [{ id: t.next.id, quantity: 1, properties: t.props }] }) });
      await fetch(`${ROOT}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', ...OWN }, body: JSON.stringify({ id: t.key, quantity: 0 }) });
      if (window.maligoProbes) { await window.maligoProbes.sync(); await window.maligoProbes.refreshCart(); }
      else location.reload();
    } catch (e) { location.reload(); }
  }

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-mgu-up]');
    if (b) upgrade(b);
  });
  let timer = null;
  const schedule = () => { clearTimeout(timer); timer = setTimeout(render, 250); };
  new MutationObserver((muts) => {
    if (muts.some((m) => [...m.addedNodes].some((n) => n.nodeType === 1 && !n.classList.contains('mgu') && (n.matches('.cart-item, .drawer__footer, cart-items, tr') || n.querySelector?.('.cart-item'))))) schedule();
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', schedule);
  if (document.readyState !== 'loading') schedule();
  window.maligoUpsell = { render, shipText };
})();
